import * as d3 from 'd3'
import Chart from '../../ultils/Chart'
// import './styles.css'

class MarblesLegend extends Chart {
  init({ data, setMarblesData, activeNode, isCompanyPage }) {
    let vis = this
    vis.data = data
    vis.setMarblesData = setMarblesData
    vis.activeNode = data[0]
    vis.isCompanyPage = isCompanyPage

    if (vis.isCompanyPage) {
      vis.svg.attr('viewBox', '0 -50 320 600')
    } else {
      vis.svg.attr('viewBox', '0 -50 350 600')
    }
    vis.svg.style('overflow', 'visible')

    vis.g
      .append('path')
      .attr(
        'd',
        'M230.363 486.725C104.794 361.156 104.794 157.569 230.363 32',
      )
      .attr('stroke', '#D1D6DE')
      .attr('stroke-width', '1.5')
      .attr('stroke-linecap', 'round')
      .attr('stroke-dasharray', '2,4')
      .attr('fill', 'none')
  }

  mappingTitle(title) {
    let mappingTitle = ''
    switch (title) {
      case 'Fire':
        mappingTitle = 'Fire'
        break
      case 'Smoke':
        mappingTitle = 'Smoke'
        break
      case 'Watchlist':
        mappingTitle = 'Watchlist'
        break
      case 'Neutral':
        mappingTitle = 'Neutral'
        break
      case 'Total':
        mappingTitle = 'Total'
        break
      default:
        mappingTitle = title
        break
    }
    return mappingTitle
  }

  update({ activeNode, data }) {
    let vis = this
    vis.data = data || vis.data
    vis.activeNode = activeNode || vis.data[0]

    const legendScale = vis.isCompanyPage ? 1.2 : 1.45
    const legendOffsetX = vis.isCompanyPage ? -30 : 16
    const legendOffsetY = vis.isCompanyPage ? -58 : -40

    if (vis.MARGIN) {
      vis.g.attr(
        'transform',
        `translate(${vis.MARGIN.LEFT + legendOffsetX}, ${vis.MARGIN.TOP + legendOffsetY}) scale(${legendScale})`,
      )
    }

    vis.g.selectAll('.circleG').remove()
    vis.circles = vis.g.selectAll('.circleG').data(vis.data)

    vis.circlesG = vis.circles
      .enter()
      .append('g')
      .attr('class', 'circleG')
      .attr('transform', d => `translate(${d.cx}, ${d.cy})`)

    const labelHeight = 34
    const labelPaddingLeft = 16
    const labelPaddingRight = 18
    const labelGap = 10
    const dotRadius = 6
    const minLabelWidth = 90

    const labelGroup = vis.circlesG
      .append('g')
      .attr('class', 'legendLabelGroup')
      .style('cursor', 'pointer')
      .on('click', (_, d) => vis.setMarblesData(d))

    labelGroup
      .append('text')
      .attr('class', 'legendLabelText')
      // .attr('x', -(dotRadius + labelGap))
      .attr('x', d =>
        d.name === vis.activeNode.name ? -(dotRadius + labelGap + 5) : -(dotRadius + labelGap),
      )
      .attr('y', 0)
      .attr('text-anchor', 'end')
      .attr('dominant-baseline', 'middle')
      .style('font-family', 'Inter')
      .style('font-size', d =>
        d.name === vis.activeNode.name ? '14px' : '14px',
      )
      .style('line-height', d =>
        d.name === vis.activeNode.name ? '16px' : '16px',
      )
      .style('font-weight', d =>
        d.name === vis.activeNode.name ? 600 : 500,
      )
      .style('fill', d =>
        d.name === vis.activeNode.name ? '#181818' : '#474747',
      )
      .text(d => vis.mappingTitle(d.title))

    labelGroup.each(function (d) {
      const g = d3.select(this)
      const textWidth = g.select('text').node().getBBox().width
      const rectWidth = Math.max(
        textWidth + labelGap + dotRadius * 2 + labelPaddingLeft + labelPaddingRight,
        minLabelWidth,
      )
      const rectX = -(textWidth + labelGap + dotRadius + labelPaddingLeft)
      g.insert('rect', 'text')
        .attr('x', rectX)
        .attr('y', -labelHeight / 2)
        .attr('width', rectWidth)
        .attr('height', labelHeight)
        .attr('rx', 4)
        .attr('ry', 4)
        .attr('fill', d.name === vis.activeNode.name ? 'transparent' : '#FFFFFF')
        .attr(
          'stroke',
          d.name === vis.activeNode.name ? 'transparent' : '#E1E5EB',
        )
    })

    const baseDotRadius = 8
    const activeOuterRadius = baseDotRadius + 3

    vis.circlesG.each(function (d) {
      const g = d3.select(this)

      if (d.name === vis.activeNode.name) {
        g.append('circle')
          .attr('class', 'legendDotShadow')
          .attr('r', activeOuterRadius)
          .attr('fill', 'none')
          .attr('stroke', d.color)
          .attr('stroke-width', 6)
          .style('pointer-events', 'none')
      }

      g.append('circle')
        .attr('class', 'legendDot')
        .attr('r', baseDotRadius)
        .attr('fill', d => (d.name === vis.activeNode.name ? d.color : d.color))
        .attr('stroke', d => {
          if (d.name === vis.activeNode.name) return '#FFFFFF'
          if (d.colorBorder) return d.colorBorder
          const lighter = d3.color(d.color)
          return lighter ? lighter.brighter(1.2).formatHex() : d.color
        })
        .attr('stroke-width', d =>
          d.name === vis.activeNode.name ? 2 : 2,
        )
        .attr('cursor', 'pointer')
        .on('click', (_, d) => vis.setMarblesData(d))
    })

    vis.companyCount = vis.circlesG
      .append('text')
      .attr('x', 18)
      .attr('y', -2)
      .attr('text-anchor', 'start')
      .attr('opacity', 0)
      .attr('class', 'legendChartCompanyCount')
      .style('font-family', 'Inter')
      .style('font-size', '16px')
      .style('font-weight', 600)
      .style('fill', '#181818')
      .text(d => d.count)

    vis.companyTitle = vis.circlesG
      .append('text')
      .attr('x', 18)
      .attr('y', 14)
      .attr('text-anchor', 'start')
      .attr('opacity', 0)
      .attr('class', 'legendChartCompany')
      .style('font-family', 'Inter')
      .style('font-size', '14px')
      .style('font-weight', 400)
      .style('fill', '#8C8C8C')
      .text('Companies')

    vis.companyCount.attr('opacity', d =>
      d.name === vis.activeNode.name ? 1 : 0,
    )

    vis.companyTitle.attr('opacity', d =>
      d.name === vis.activeNode.name ? 1 : 0,
    )
  }
}

export default MarblesLegend
